import { resolveSource, sourceLabel } from "../services/leadSources";

/**
 * Chip que marca un registro como IMPORTADO de otro sistema. Hoy sólo existe
 * HubSpot: todo lo que trae la integración llega con `source: "hubspot"`. Para
 * cualquier otro origen (o sin origen) no pinta nada.
 */
export function ImportedFromTag({ source }: { source?: string | null }) {
  const def = resolveSource(source);
  if (def.key !== "hubspot") return null;
  return (
    <span
      title="Importado de HubSpot"
      data-testid="imported-from-hubspot"
      className={`inline-flex items-center gap-0.5 whitespace-nowrap rounded-full px-1.5 py-0.5 align-middle text-[10px] font-semibold ${def.tone}`}
    >
      <i className={def.icon} />
      HubSpot
    </span>
  );
}

/**
 * Celda de la columna «Origen» de Contactos, Empresas y Negocios: de dónde vino
 * el registro. Lo importado de HubSpot lleva su etiqueta; cualquier otro origen
 * conocido, su nombre; sin origen, una raya.
 */
export function OriginCell({ source }: { source?: string | null }) {
  if (resolveSource(source).key === "hubspot") return <ImportedFromTag source={source} />;
  const label = sourceLabel(source);
  return <span className="whitespace-nowrap text-xs opacity-80">{label && label !== "—" ? label : "—"}</span>;
}
